module.exports = __webpack_public_path__ + "Employer Notice 8_8_2024.pdf";